import Vue from 'vue';
import App from './App.vue';

import wrap from '@vue/web-component-wrapper';

let isComponent = false;

// import { BootstrapVue } from 'bootstrap-vue';
// import VueClipboard from 'vue-clipboard2';
// //import VueShepherd from 'vue-shepherd';
// import VueHead from 'vue-head';
// import Vuelidate from 'vuelidate';
// import NProgress from 'vue-nprogress';
// import VCalendar from 'v-calendar';
// import { loadStripe } from '@stripe/stripe-js';

// import layoutBlank from '@/components/layouts/layout-blank.vue';
// import layoutSecondary from '@/components/layouts/layout-secondary.vue';

// import VHighlightJS from '@/lib/highlighter.js';

// Vue.config.productionTip = false;

// Vue.config.errorHandler = function(err, vm, info) {
// 	console.log(err);
// };

// Vue.use(VHighlightJS);
// Vue.use(Vuelidate);
// Vue.use(VueHead);
// //Vue.use(VueShepherd);
// Vue.use(VueClipboard);
// Vue.use(BootstrapVue);
// Vue.use(NProgress);
// Vue.use(VCalendar, {});

// Vue.component('layout-blank', layoutBlank);
// Vue.component('layout-secondary', layoutSecondary);

// const nprogress = new NProgress();

// let stripePublishableKey =
// 	'pk_test_51HE8UjHQAqGl0SYu7g24DXaXrlQTEJKyAMdIL2xpitAoNZIepPEWPznFqQUfpjqSBxpuDGUfejAhcCQArDSSaYh300yP36YtaH';
// if (process.env.NODE_ENV === 'production') {
// 	stripePublishableKey =
// 		'pk_live_51HE8UjHQAqGl0SYuG52eoyb2MZjknzQx982EMn6hbaGkbjXJBxTUwhtEYeZobZaFmL1QWwKGHYL00DdtnooEN3gz002neGtsOj';
// }

//loadStripe(stripePublishableKey).then(stripe => {
//Vue.prototype.$stripe = stripe;

if (!isComponent) {
	new Vue({
		render: h => h(App),
		methods: {},
		mounted: function() {}
	}).$mount('#app');
} else {
	const WrappedElement = wrap(Vue, App);
	window.customElements.define('underline-me', WrappedElement);
}
//});
